import { CardSvg } from '@/play/cardSvg'

/** Home card art: a canvas on a wooden floor, a drop falling, splats with their spatter. */
export function Splat2CardArt() {
  return (
    <CardSvg bg="#5d4636">
      <rect x="0" y="92" width="320" height="108" fill="#b7895c" />
      <path d="M0 118 H320 M0 146 H320 M0 176 H320" stroke="#8a6440" strokeWidth="2" />
      <path d="M44 96 L276 96 L300 188 L20 188 Z" fill="#f5f0e4" />
      <path d="M20 188 L300 188 L300 193 L20 193 Z" fill="#e2d9c5" />
      {/* a red splat with spatter */}
      <ellipse cx="120" cy="150" rx="40" ry="16" fill="#f0242a" />
      <ellipse cx="108" cy="145" rx="13" ry="4" fill="#ffffff" opacity="0.6" />
      <ellipse cx="62" cy="160" rx="6" ry="3" fill="#f0242a" />
      <ellipse cx="172" cy="166" rx="5" ry="2.5" fill="#f0242a" />
      <ellipse cx="96" cy="128" rx="4" ry="2" fill="#f0242a" />
      {/* a blue one fused with it */}
      <ellipse cx="170" cy="138" rx="30" ry="12" fill="#2459e0" />
      <ellipse cx="162" cy="134" rx="9" ry="3" fill="#ffffff" opacity="0.6" />
      <ellipse cx="214" cy="130" rx="4" ry="2" fill="#2459e0" />
      {/* a yellow drop falling, stretched, its shadow under it */}
      <ellipse cx="236" cy="160" rx="16" ry="5" fill="#3a2614" opacity="0.2" />
      <ellipse cx="236" cy="58" rx="13" ry="20" fill="#ffd60a" />
      <ellipse cx="231" cy="51" rx="4" ry="7" fill="#ffffff" opacity="0.65" />
    </CardSvg>
  )
}
